import { Component, OnInit } from '@angular/core';

import { BreadcrumbDataService } from '../../services/breadcrumb-data.service';

@Component({
  selector: 'renci-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {

  constructor(public data: BreadcrumbDataService) { }

  ngOnInit() {
  }

}
